import React, { FC } from "react";
import {
    ArticleTitle,
    TitleBackplate,
    TitleHead,
    TitleTextLarge,
} from "../../components/articles/header/style";
import { Main } from "../../components/articles";
import {
    ArticleLayout,
    ArticleLink,
    ArticleText,
    AuthorPubDate,
    Content,
    ArticleSpace,
    Header,
    AuthorAvatar,
    AuthorName,
    AuthorPost,
    Author,
} from "../../components/articles/article/style";
import {
    Facebook,
    LinkedIn,
    RightContent,
    Share,
    ShareHeader,
    ShareSocialList,
    StickyWrapper,
    Telegram,
} from "../../components/articles/right/style";
import LearnMore from "../../components/learn_more";

const ThirdArticlePage: FC = () => {
    return (
        <Main>
            <ArticleTitle>
                <TitleBackplate imagePath={`${process.env.PUBLIC_URL}/articles/bplt.svg`} />
                <TitleTextLarge>
                    <TitleHead>
                        <br />
                        <br />
                        Press release: Offsetted Finance launch at the Singapore Fintech Festival
                    </TitleHead>
                </TitleTextLarge>
            </ArticleTitle>
            <ArticleSpace>
                <ArticleLayout>
                    <Header>
                        <Author>
                            <AuthorAvatar src={`${process.env.PUBLIC_URL}/articles/daria.jpeg`} />
                            <AuthorName>Daria Lipatova</AuthorName>
                            <AuthorPost>Co-Founder, Managing Director Offsetted</AuthorPost>
                        </Author>
                        <AuthorPubDate>November 02, 2022</AuthorPubDate>
                    </Header>
                    <Content>
                        <ArticleText>
                            Climate tech software company Offsetted today launched an Environmental,
                            Social, and Governance (ESG) compliance solution - Offsetted Finance, to
                            help the financial industry and real sector reduce their environmental
                            impact and report on ESG-related disclosures.
                            <br /> <br />
                            Offsetted Finance is a Software-as-a-Service (SaaS) that empowers
                            privately-owned financial institutions and publicly traded companies at
                            the Singapore Exchange (SGX) to understand their carbon footprint, model
                            emission reduction plans, and perform ESG-related disclosures. The
                            product will also provide organizations with data-driven, actionable
                            insights on their ESG performance improvement in line with
                            industry-specific benchmarking and scoring. Offsetted Finance is aligned
                            with recognized international standards and frameworks such as the
                            Global Reporting Initiative (GRI), Task Force on Climate-Related
                            Financial Disclosures (TCFD), and Sustainable Development Goals (SDG).
                            The product launch was officiated by Alex Lazarenko and Daria Lipatova,
                            founders of Offsetted, at the Singapore Fintech Festival.
                            <br /> <br />
                            “Offsetted Finance is destined to assist financial institutions, as well
                            as companies in the real sector, on their path to net zero by providing
                            an accessible one-stop-shop solution to understand their emissions and
                            obtain an ESG score,” said Daria Lipatova, Co-Founder and Managing
                            Director of Offsetted. “We believe that by providing a simple,
                            accessible tool for assessing and acting on both direct and indirect
                            emissions, the latter of the most important to the financial sector,
                            Offsetted Finance enables organisations to respond to regulatory
                            pressure easily. In addition to that, we assist our clients in creating
                            long-term business growth opportunities utilizing various footprint
                            reduction and decarbonisation solutions.”
                            <br /> <br />
                            For additional information, please contact:
                            <br /> <br /> Daria Lipatova, Co-Founder, Managing Director, Offsetted
                            <br />
                            <ArticleLink href='mailto:daria@offsetted.com'>
                                daria@offsetted.com
                            </ArticleLink>
                            <br />
                            <ArticleLink href='tel:daria@offsetted.com'>+65 817 03 503</ArticleLink>
                        </ArticleText>
                    </Content>
                </ArticleLayout>
                <LearnMore />
            </ArticleSpace>
            <RightContent>
                <StickyWrapper>
                    <Share>
                        <ShareHeader>Share the article</ShareHeader>
                        <ShareSocialList>
                            <Facebook
                                href='https://facebook.com/sharer/sharer.php?u=https://offsetted.com/oftd-finance'
                                target='_blank'
                                rel='noopener noreferrer'
                            />
                            <LinkedIn
                                href='https://www.linkedin.com/shareArticle?url=https%3A//offsetted.com/oftd-finance'
                                target='_blank'
                                rel='noopener noreferrer'
                            />
                            <Telegram
                                rel='noopener noreferrer'
                                target='_blank'
                                href='https://telegram.me/share/url?url=https://offsetted.com/oftd-finance'
                            />
                        </ShareSocialList>
                    </Share>
                </StickyWrapper>
            </RightContent>
        </Main>
    );
};

export default ThirdArticlePage;
